/**
 * Accessibility Fixes
 * Improves accessibility for dynamically loaded content
 */

document.addEventListener('DOMContentLoaded', function() {
  // Fix iframe accessibility
  function fixIframeAccessibility() {
    const iframes = document.querySelectorAll('iframe');
    
    iframes.forEach(function(iframe) {
      // Check if iframe already has accessible name
      const hasAccessibleName = iframe.hasAttribute('title') || 
                                iframe.hasAttribute('aria-label') || 
                                iframe.hasAttribute('aria-labelledby');
      
      if (!hasAccessibleName) {
        // Determine appropriate title based on src or id
        let title = 'Embedded content';
        
        if (iframe.id && iframe.id.includes('PBarNextFrame')) {
          title = 'Shopify Preview Bar';
        } else if (iframe.src && iframe.src.includes('preview-bar')) {
          title = 'Shopify Preview Bar';
        } else if (iframe.src && iframe.src.includes('youtube')) {
          title = 'YouTube video player';
        } else if (iframe.src && iframe.src.includes('vimeo')) {
          title = 'Vimeo video player';
        } else if (iframe.src && iframe.src.includes('shopify')) {
          title = 'Shopify embedded content';
        }
        
        iframe.setAttribute('title', title);
      }
    });
  }
  
  // Run immediately
  fixIframeAccessibility();
  
  // Also run when new content is dynamically loaded
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if any new iframes were added
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.tagName === 'IFRAME') {
              // Single iframe added
              fixIframeAccessibility();
            } else if (node.querySelectorAll && node.querySelectorAll('iframe').length > 0) {
              // Container with iframes added
              fixIframeAccessibility();
            }
          }
        });
      }
    });
  });
  
  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}); 